export default __webpack_public_path__ + "static/media/37.e9792f59.jpg";